<template>
  <div id="DocumentLimitTransactionAgrees" class="sun not-full">
    <div class="item" v-for="(agreement, index) in agreements" :key="index">
      <div class="index">
        {{index+1}}.
      </div>
      <div class="question">
        {{agreement.question}}
      </div>
      <div class="button">
        <button class="w-80 h-48px"
                :class="{'active':agreement.is_agreed}"
                @click="agree(agreement)">
          {{agreement.content}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentLimitTransactionAgrees',
  data: function () {
    return {
      agreements: [
        {
          question: '위 계약서 및 온라인연계 대출계약 약관을 확실히 수령하였습니까?',
          content: '수령함',
          is_agreed: false
        }, {
          question: '위 계약서 및 온라인연계 대출계약 약관의 중요한 내용에 대하여 설명을 들었습니까?',
          content: '들었음',
          is_agreed: false
        }, {
          question: '중개수수료를 채무자로부터 받는 것이 불법이라는 설명을 들었습니까?',
          content: '들었음',
          is_agreed: false
        },
      ]

    }
  },
  computed: {},
  created() {
    if (this.isAgreed) {
      for (let agreement of this.agreements) {
        agreement.is_agreed = true
      }
    }
  },
  destroyed() {},
  methods: {
    agree(agreement) {
      agreement.is_agreed = !agreement.is_agreed
      this.checkAll()
    },
    checkAll() {
      let isAgreedAgreements = this._.every(this.agreements, 'is_agreed')
      if (isAgreedAgreements) {
        this.$emit('complete')
      } else {
        this.$emit('cancel')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  #DocumentLimitTransactionAgrees {
    width: 100%;
    float: left;

    .item {
      width: 100%;
      display: block;
      float: left;

      .index {
        display: inline-block;
        float: left;
        width: calc(20% / 325 * 100);
      }

      .question {
        display: inline-block;
        float: left;
        width: calc(210% / 325 * 100);
      }

      .button {
        display: inline-block;
        float: right;
        width: calc(95% / 325 * 100);

        button, button:hover {
          width: 80%;
          height: 48px;
          border-radius: 4px;
          border: solid 1px #d7e1ea;
          font-size: 15px;
          color: #8a94a2;
          background-color: #f4faff;
          &.active, &.active:hover {
            font-weight: 600;
            color: #1baaf1;
            background-color: #ffffff;
          }
        }
      }
    }

    .item:first-child {
      margin-top: 30px;
    }
    .item:not(:first-child) {
      margin-top: 20px;
    }

    .item:last-child {
      margin-bottom: 30px;
    }
  }
</style>
